import { render, staticRenderFns } from "./checkReportKneeHurt.vue?vue&type=template&id=0e0d2af6&scoped=true&"
import script from "./checkReportKneeHurt.vue?vue&type=script&lang=js&"
export * from "./checkReportKneeHurt.vue?vue&type=script&lang=js&"
import style0 from "./checkReportKneeHurt.vue?vue&type=style&index=0&id=0e0d2af6&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0d2af6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e0d2af6')) {
      api.createRecord('0e0d2af6', component.options)
    } else {
      api.reload('0e0d2af6', component.options)
    }
    module.hot.accept("./checkReportKneeHurt.vue?vue&type=template&id=0e0d2af6&scoped=true&", function () {
      api.rerender('0e0d2af6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/check/components/checkReportKneeHurt.vue"
export default component.exports